import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-abe11420"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "svg-inline",
  viewBox: "0 0 61 61",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M46.2404 22.5L30.4376 14.5L14.6348 22.5M46.2404 22.5V38.5L30.4376 46.5L14.6348 38.5V22.5M46.2404 22.5L30.4376 30.5M14.6348 22.5L30.4376 30.5M30.4376 30.5V45.6111M39.2169 32.2778V26.0556L23.4141 18.0556",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round"
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}